<template>
    <div class="container">
        <h1>National Facilities</h1>
        <div class="row justify-content-center">
            <div class="col">
                <FacilitiesTable show-profile show-acceptance show-qa show-reviewers show-documents show-admin-actions />
            </div>
        </div>
    </div>
</template>

<script>
import FacilitiesTable from '@/components/facilities/FacilitiesTable.vue'
export default {
    name: 'EditUsers',
    components: {
        FacilitiesTable
    },
    data: () => {
        return {
        }
    },
    head: {
        title: 'National Facilities'
    },
    methods: {
    },
    async mounted() {
    }
}
</script>